// extracted by mini-css-extract-plugin
module.exports = {"container":"Form__container___U6c9f","alignCenter":"Form__alignCenter___bD7bM"};